import { axiosGetWithHeaders } from 'src/utils/httpClient';
// import { IGetRafflesResponse } from './playerService';
import { addQueryParams } from 'src/utils/url';

const moderateService = {
  async getChallenges({
    name,
    page,
    size,
    sortColumn,
    sortOrder,
  }: {
    name?: string | null;
    page: number;
    size: number;
    sortColumn?: string | null;
    sortOrder?: string;
  }): Promise<any> {
    // let url = `/admin/all/challenges?&page=${page}&size=${size}`;
    const url = `/admin/all/challenges`;

    let formedUrl = addQueryParams(url, {
      page,
      size,
      name,
    });

    if (sortColumn && sortOrder) {
      formedUrl += `&sort=${sortColumn},${sortOrder}`;
    }

    const response = await axiosGetWithHeaders(formedUrl);

    return {
      data: response.data,
      total: parseInt(response.headers['x-total-count'], 10),
    };
  },
};

export default moderateService;
